module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Food/Two-bottles-35a9abe30b38af535f17a89edb334456.svg";